import { render, staticRenderFns } from "./04.vue?vue&type=template&id=5116d61b&scoped=true"
import script from "./04.vue?vue&type=script&lang=js"
export * from "./04.vue?vue&type=script&lang=js"
import style0 from "./04.vue?vue&type=style&index=0&id=5116d61b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5116d61b",
  null
  
)

export default component.exports